import {
  APP_INITIALIZER,
  EnvironmentProviders,
  InjectionToken,
  ValueSansProvider,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import { FeatureFlag } from './feature-flag.interface';
import { FeatureFlagsService } from './feature-flag.service';

export const FEATURE_FLAGS = new InjectionToken('FEATURE_FLAGS', {
  providedIn: 'root',
  factory: () => ({}),
});

export interface FeatureFlagUseValue extends ValueSansProvider {
  useValue: FeatureFlag;
}

export function initializeFeatureFlags() {
  const featureFlagsFacade = inject(FeatureFlagsService);
  return () => featureFlagsFacade.loadFeatureFlags();
}

export function provideFeatureFlags(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: FEATURE_FLAGS,
      multi: true,
      useValue: [],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => initializeFeatureFlags(),
      deps: [FeatureFlagsService],
      multi: true,
    },
  ]);
}
